export default __webpack_public_path__ + "static/media/35_TopRightSquares_RotateLeft.8a8cbb78.mp4";